export const HOME = '/'
export const TERM = '/term'
export const NOTICE = '/notice'
export const POLICY = '/policy'
export const PAYMENT_POLICY = '/payment_policy'